import React from 'react'
import { styled } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import clsx from 'clsx'

type DropdownInputProps = {
  className?: string
  title?: string
  onRefresh?: (...args: unknown[]) => void | Promise<void>
  toggleMenu?: () => void
  isOpen?: boolean
}
export default styled(
  React.forwardRef<HTMLInputElement, DropdownInputProps>(
    ({ className, onRefresh, toggleMenu, isOpen, ...rest }: DropdownInputProps, ref) => (
      <div className={clsx(className, 'input')}>
        <FontAwesomeIcon solid size="sm">
          magnifying-glass
        </FontAwesomeIcon>
        <input {...rest} ref={ref} onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} />
        {onRefresh && (
          <FontAwesomeIcon
            className="refreshIcon"
            solid
            size="sm"
            onClick={() => {
              isOpen && toggleMenu()
              onRefresh(true)
            }}
          >
            arrows-rotate
          </FontAwesomeIcon>
        )}
      </div>
    ),
  ),
)<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  color: theme.components.input.frame.color,
  padding: '0 8px',
  '& > input': {
    margin: '2px 10px 0 0',
    transition: 'color .2s ease',
    outline: 0,
    flexGrow: 1,
    caretColor: theme.components.input.frame.color,
    background: 'transparent',
    color: 'inherit',
    boxSizing: 'border-box',
    border: 'none',
    lineHeight: 2.4,
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  '& > i': {
    color: theme.components.input.frame.placeholder,
    marginRight: 8,
  },
  '& > .refreshIcon': {
    marginRight: 0,
  },
}))
